import {t} from 'i18next';
import AurUploadBox from '../common/aur-uploadbox/AurUploadBox';
import {ReactComponent as DownloadIcon} from '../../../src/assests/svg/download-icon.svg';

// Refactored code to remove duplicate code.
const BulkUserDownloadTemplate = () => {
  return (
    <div className="template-content">
      <AurUploadBox
        title={t('common.aurUploadBox.templateTitle')}
        description={t('common.aurUploadBox.templateDescription')}
        buttonLabel={t('common.aurUploadBox.templateButton')}
        buttonIcon={<DownloadIcon aria-hidden="true" />}
        isDragDrop={false}
        orText={false}
        buttonHint={t('common.aurUploadBox.templateButtonHint')}
        ButtonClassNames={'template-download-button'}
      />
    </div>
  );
};

export default BulkUserDownloadTemplate;
